// extracted by mini-css-extract-plugin
export default {"container":"wk-z","blurb":"xk-z","links":"yk-z"};